import { render } from "./WpeMedia.vue?vue&type=template&id=78bba8bc"
import script from "./WpeMedia.vue?vue&type=script&lang=js"
export * from "./WpeMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeMedia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78bba8bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78bba8bc', __exports__)) {
    api.reload('78bba8bc', __exports__)
  }
  
  module.hot.accept("./WpeMedia.vue?vue&type=template&id=78bba8bc", () => {
    api.rerender('78bba8bc', render)
  })

}


export default __exports__